export const GET_PROGRAM_SUBCATEGORIES = "GET_PROGRAM_SUBCATEGORIES";
export const GET_PROGRAM_SUBCATEGORY_BY_ID = "GET_PROGRAM_SUBCATEGORY_BY_ID";
export const UPDATE_PROGRAM_SUBCATEGORY = "UPDATE_PROGRAM_SUBCATEGORY";
export const DELETE_PROGRAM_SUBCATEGORY = "DELETE_PROGRAM_SUBCATEGORY";
export const CREATE_PROGRAM_SUBCATEGORY = "CREATE_PROGRAM_SUBCATEGORY";
